<template>
  <van-popup
    v-model="show"
    :overlay="false"
    z-index="2"
    position="bottom"
    :style="{ height: '100vh' }"
    :lock-scroll="false"
  >
    <div class="wrapper">
      <div class="block">
        <div class="button-close" @click="onCloseClick()">
          <img
            style="height: 19px"
            :src="require('../../../assets/imgs/icon/bottom-modal-close.png')"
          />
        </div>

        <div class="content-container">
          <div
            class="level-item"
            v-for="item in levels"
            :key="item.contentId"
            @click="onLevelSelect(item)"
          >
            <div
              :class="
                selectLevel.contentId == item.contentId
                  ? 'button-level-active'
                  : 'button-level-normal'
              "
            >
              {{ item.difficultyTitle }}
            </div>
            <div class="text-level-desc">{{ item.difficultyDescription }}</div>
          </div>
          <div style="height: 50px; background-color: #fff"></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import * as ActionTypes from "../../../store/action-types";
import { mapState } from "vuex";

export default {
  name: "LevelSelectorModal",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    onLevelChange: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // show: true,
    };
  },
  computed: {
    ...mapState({
      contentId: (state) => state.article.contentId,
      levels: (state) => state.article.levels,
    }),
    selectLevel() {
      let level = _.filter(
        this.$store.state.article.levels,
        (item) => item.contentId == this.contentId
      );
      return level[0];
    },
  },
  methods: {
    onLevelSelect(levelItem) {
      this.onLevelChange(levelItem);
      // this.$store.dispatch(ActionTypes.READING_SWITCH_LEVEL,levelItem)
    },
    onCloseClick() {
      this.onClose();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #00000066;
}

.block {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  height: 70vh;
  width: 100%;
  padding-bottom: 50px;
  border-radius: 20px 20px 0 0;
}

.content-container {
  height: 100%;
  padding: 20px 39px;
  text-align: center;
  overflow: auto;
}

.level-item {
  margin-bottom: 30px;
}

.button-level {
  &-active {
    font-size: 12px;
    color: #ffffff;
    line-height: 28px;
    border-radius: 14px;
    background: linear-gradient(right, #98CEFF, #3994E7);
  }

  &-normal {
    font-size: 12px;
    color: #3994E7;
    line-height: 28px;
    border-radius: 14px;
    border: 1px solid #3994E7;
  }
}

.text-level-desc {
  margin-top: 10px;
  font-size: 12px;
  transform: scale(0.9);
  color: #333333;
}

.button-close {
  text-align: center;
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/LevelSelectorModal.vue